import React, {useEffect} from 'react';

export const MarquizBtn = () => {
  useEffect(() => {
    const w = window as any;  // Хак: Кастуем window к any, чтобы игнорировать TS-ошибки для Marquiz

    // Проверяем, загружен ли Marquiz (чтобы избежать ошибок)
    if (!w.Marquiz && !document.querySelector('[data-marquiz-id="687015074f51b500197dba38"]')) {
      // Ждём события marquizLoaded, если нужно
      const onLoaded = () => {
        addMarquizButton();
      };
      document.addEventListener('marquizLoaded', onLoaded);
      return () => document.removeEventListener('marquizLoaded', onLoaded);
    } else {
      addMarquizButton();
    }
  }, []);

  const addMarquizButton = () => {
    const w = window as any;  // Повторяем хак здесь для функции

    // Проверяем, чтобы не добавлять кнопку несколько раз (избегаем дубликатов)
    if (document.querySelector('.marquiz__button')) return;  // Marquiz добавляет класс .marquiz__button

    // Выполняем функцию добавления кнопки (из вашего кода)
    (function (t, p) {
      w.Marquiz ? w.Marquiz.add([t, p]) : document.addEventListener('marquizLoaded', function () {
        if (w.Marquiz) {
          w.Marquiz.add([t, p]);
        }
      });
    })('Button', {
      id: '687015074f51b500197dba38',
      buttonText: 'Подобрать квартиру',
      bgColor: '#bb9056',
      textColor: '#ffffff',
      rounded: true,
      shadow: 'rgba(187, 144, 86, 0.5)',
      blicked: true,
      fixed: 'left',
      disableOnMobile: false
    });
  };

  return (
    <div data-marquiz-id="687015074f51b500197dba38"></div>  // Контейнер для кнопки
  );
};